var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35079 8.31524V11.5749H0.720947V13.2048H3.16572V14.8346H4.79556V13.2048H6.42541V14.8346H8.05525V13.1632C9.65902 12.9603 10.9075 11.6026 10.9075 9.94509C10.9075 8.86939 10.3778 7.92082 9.57101 7.32674C10.166 6.72046 10.4996 5.90503 10.5 5.05555C10.5 3.54142 9.45773 2.27585 8.05525 1.91158V0.166016H6.42541V1.79586H4.79556V0.166016H3.16572V1.79586H0.720947V3.42571H2.35079V8.31524ZM7.64779 11.5749H3.98064V8.31524H7.64779C8.54665 8.31524 9.27763 9.04623 9.27763 9.94509C9.27763 10.8439 8.54665 11.5749 7.64779 11.5749ZM3.98064 3.42571H7.24033C8.13919 3.42571 8.87017 4.15669 8.87017 5.05555C8.87017 5.95441 8.13919 6.6854 7.24033 6.6854H3.98064V3.42571Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.f6b60bbe.svg";
export { ForwardRef as ReactComponent };